import styled from '@emotion/styled';
import { Button } from 'ds/components/button';
import { TextLabel } from 'ds/components/typography';

export const Root = styled.div<{ equalWidthButtons?: boolean }>(({ theme, equalWidthButtons }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& button[disabled]': {
    maxWidth: '200px',
  },
  '& button': {
    minWidth: '200px',
  },
  ...(equalWidthButtons && {
    flexGrow: 1,
    '& button, & > div:first-of-type': {
      flexBasis: '50%',
      minWidth: 'unset',
      whiteSpace: 'nowrap',
    },
    '& button:nth-child(1)': {
      flexBasis: '100%',
      maxWidth: 'unset',
    },
    '& > div:first-of-type': {
      flexGrow: 1,
    },
  }),
}));

export const Form = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

export const FormRoot = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(0.5),
  'input': {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    maxHeight: '32px',
  },
}));

export const Label = styled(TextLabel)(({ theme }) => ({
  color: theme.colors.neutrals.grey3,
  whiteSpace: 'pre',
}));

export const LinkLabel = styled(Label.withComponent('a'))(({ theme }) => ({
  color: theme.colors.neutrals.grey3,
}));

export const Hint = styled.div({
  display: 'flex',
  height: '20px',
  alignItems: 'center',
});

export const CloseIconWrap = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginLeft: theme.spacing(1),
  ':hover svg path': {
    fill: theme.colors.neutrals.grey1,
  },
}));

export const ContactButton = styled(Button)(({ theme }) => ({
  ':hover': {
    color: theme.colors.brand.secondary,
    borderColor: theme.colors.neutrals.grey8,
    'svg path:last-of-type': {
      stroke: theme.colors.brand.secondary,
    },
  },
  '&[disabled] svg path:last-of-type': {
    stroke: theme.colors.neutrals.grey4,
  },
}));
